import { http } from '@/http/axios.js';

// 列表
export function getListAPI(params) {
  return http({
    url: '/admin/member/page',
    method: 'get',
    params
  })
}

// 详情
export function getDetailAPI(id) {
  return http({
    url: '/admin/member/detail',
    method: 'get',
    params: { id }
  })
}
